/**
 * 给个位数补零
 * @param {Number} - num
 * @return {String}
 */
export function complement0(num) {
  if (num < 0) return num
  num = String(num)
  return num.length === 1 ? `0${num}` : num
}

/**
 * 防抖函数
 * @param {Function} fn 
 * @param {Number} delay - 延迟（毫秒）
 * @param {Object} opts 
 * @param {Boolean} opts.leading - 是否在开始执行
 * @param {Boolean} opts.trailing - 是否在结束时执行
 * @returns {Function}
 */
export function debounce(
  fn, 
  delay, 
  opts = { leading: false, trailing: true }
) {
  let timeout = null
  return function(...args) {
    if (!timeout && opts.leading) {
      fn.apply(this, args)
    }

    if (timeout) clearTimeout(timeout)

    timeout = setTimeout(() => {
      if (opts.trailing) {
        fn.apply(this, args)
      }
      timeout = null
    }, delay)
  }
}

/**
 * get file type
 * @param {string} fileName
 */
 export function getFileType(fileName) {
  const index = fileName.lastIndexOf('.');
  return fileName.substring(index + 1, fileName.length);
}